export default __webpack_public_path__ + "static/media/Macrobac-35-ml-ban.317a740b.jpg";